import { Component, OnInit, Input, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dcl-baymax-header',
    templateUrl: './baymax-header.component.html',
    styleUrls: ['./baymax-header.component.scss']
})
export class BaymaxHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() title: string;
    @Input() isCloseBtn: boolean;
    @Input() isModal: boolean;
    @Input() parent: string;
    @Input() animationDelay: number;
    @Output() iconEvent = new EventEmitter();

    private baymaxElement;
    private iconElement;

    constructor() { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        // Header under modal
        this.baymaxElement = document.querySelector('.baymax-header.is-not-modal');

        // If there are two headers in the same page (one in an open modal and the other in the page)
        // set page header tabindex to -1, so there is no conflict with the one in the modal
        if (this.baymaxElement && this.isModal) {
            this.iconElement = this.baymaxElement.querySelector('.dcl-link');
            this.baymaxElement.setAttribute('aria-hidden', 'true');
            this.iconElement.setAttribute('tabindex', '-1');
        }
    }

    ngOnDestroy() {
        // When modal is closed, the page header returns to the default settings
        if (this.baymaxElement && this.isModal) {
            this.baymaxElement.removeAttribute('aria-hidden');
            this.iconElement.setAttribute('tabindex', '0');
        }
    }

    onIconClick() {
        this.iconEvent.emit();
    }
}
